// Long-form legal / policy content for dedicated pages.
export const LEGAL_PAGES = {
  "privacy-policy": {
    metaTitle: "Privacy Policy | Urgent Passport & Visa (UPV Services)",
    metaDescription:
      "Read the UPV Services privacy policy. Learn how Urgent Passport & Visa collects, secures, and uses your personal and travel document information.",
    overline: "Legal",
    h1: "Privacy Policy",
    lastModified: "9/1/2025",
    intro:
      "UPV Services respects the privacy of the users of our services and website. To that effect, we have instituted the following Privacy Policy:",
    blocks: [
      {
        h2: "Collection of Information from our Clients",
        paragraphs: [
          "In order to process your order, we need to know some standard information such as your name, e-mail address, mailing address, credit card number and telephone number. For the purpose of filing your travel documents we need to know the following information: your date of birth, social security number, and photographs. For the purpose of filing your travel documents we will need access to the following documents: prior US Passport, travel itinerary, birth certificate, and driver's license.",
          "It is our policy that this information is private and confidential. Accordingly, the personal information you provide is stored in a secure location, is accessible only by designated staff, and is used only for the purposes for which you provide the information. When you submit an order, your information is encrypted with secure server software to protect the information from unauthorized access. We will not sell, rent or trade any personal information we collect from you on our website.",
        ],
      },
      {
        h2: "E-mail Updates",
        paragraphs: [
          "UPV Services may occasionally notify you of new services and special offers via e-mail updates. If you would rather not receive any updates from us, please send a request to be removed from our e-mail update list to: info@upvservices.com.",
        ],
      },
      {
        h2: "No Computer Tracking of Identifiable Information",
        paragraphs: [
          "Our computer is not set up to track, collect or distribute personal information about its visitors. It does recognize the home server of visitors, but not e-mail addresses. For example, we can tell which Internet Service Provider our visitors use, but not the names, addresses or other information about our visitors that would allow us to identify the particular visitors to our sites.",
          "In addition, our websites track information about the visits to our websites. For example, we compile statistics that show the daily number of visitors to our sites, the daily requests we receive for particular files on our websites, and what countries those requests come from. These aggregated statistics are used internally to better provide services to the public and may also be provided to others, but again, the statistics contain no personal information and cannot be used to gather such information.",
        ],
      },
      {
        h2: "Updates or Amendments to this Privacy Policy",
        paragraphs: [
          "We reserve the right to periodically amend or revise the Privacy Policy; material changes will be effective immediately upon the display of the revised Privacy Policy. The last revision will be reflected in the \"Last modified\" section. Your continued use of the Platform, following the notification of such amendments on our website, constitutes your acknowledgment and consent of such amendments to the Privacy Policy and your agreement to be bound by the terms of such amendments.",
        ],
      },
      {
        h2: "How to Contact Us",
        paragraphs: [
          "If you have any general questions about the Site or the information we collect about you and how we use it, you can contact us at info@upvservices.com.",
        ],
      },
    ],
  },
  "guarantee": {
    metaTitle: "Guarantee & Legal | Urgent Passport & Visa (UPV Services)",
    metaDescription:
      "UPV Services guarantee and legal disclaimer. Urgent Passport & Visa is a private courier service — not a government agency — that helps prepare and hand-carry your passport and visa applications.",
    overline: "Legal",
    h1: "Guarantee & Legal",
    intro: "If you need a U.S. Passport in a hurry, UPV Services can help.",
    blocks: [
      {
        h2: "How We Help",
        paragraphs: [
          "UPV Services is a private courier company. We are not a government agency and are not affiliated with, endorsed by, or sponsored by the U.S. Department of State or any other government entity. What we do is help you prepare a complete, error-free application and hand-carry it to the appropriate passport agency, embassy, or consulate so it can be submitted as efficiently as possible.",
          "Processing times are set and controlled by the U.S. government and applicable embassies. They are estimates only and cannot be guaranteed. Mandatory government fees are paid to the government and are separate from and in addition to our service fees.",
          "So if you need a passport right away, do not delay; contact us to get started.",
        ],
      },
      {
        h2: "Scope of Service & Liability",
        paragraphs: [
          "UPV Services acts solely as an agent on behalf of the applicant and accepts no responsibility for the services provided by the Passport Agency, any Consulate, or Embassy regarding the issuance of passports or visas. UPV Services is not liable for any delays, loss of passports, documents, or other materials caused by these entities or by any delivery services such as FedEx, UPS, USPS, or similar carriers. UPV Services does not offer damage compensation.",
          "All this means is that our service guarantee is limited to circumstances within UPV Services' control. UPV Services does not hold insurance for any such losses or damages, and no damage compensation is available.",
          "For instance, UPV Services is not responsible for service delays or errors of Federal Express or other overnight courier services if they fail to meet their delivery commitments. UPV Services also cannot be held responsible if the Passport Agency denies a passport application.",
          "If you have questions regarding our guarantee, please contact UPV Services directly.",
        ],
      },
    ],
  },
  "drug-free-workplace-policy": {
    metaTitle: "Drug-Free Workplace Policy | Urgent Passport & Visa",
    metaDescription:
      "UPV Services maintains a strict Drug-Free Workplace Policy in compliance with U.S. Department of State Courier Program requirements (22 CFR Part 54).",
    overline: "Compliance",
    h1: "Drug-Free Workplace Policy",
    intro:
      "(In Compliance with U.S. Department of State Courier Program Requirements – 22 CFR Part 54, Page 46108) UPV Services maintains a strict Drug-Free Workplace Policy to comply with federal regulations for passport and visa processing companies, including the Department of State's requirements for courier operations. This policy is designed to ensure safety, security, and integrity in the handling of sensitive government documents.",
    blocks: [
      {
        h2: "1. Policy Statement",
        paragraphs: [
          "UPV Services prohibits the unlawful manufacture, distribution, dispensing, possession, or use of controlled substances in the workplace or while performing any business activities related to passport, visa, or document-processing services.",
          "Violation of this policy may result in disciplinary action, up to and including termination of employment or contract, and/or referral to law enforcement.",
        ],
      },
      {
        h2: "2. Drug-Free Awareness Program",
        paragraphs: [
          "To maintain compliance with federal requirements, UPV Services operates a Drug-Free Awareness Program that informs all employees and contractors about the dangers and risks associated with drug use, the company's Drug-Free Workplace Policy, available employee assistance, counseling, or rehabilitation programs, and potential consequences for violating this policy.",
          "All team members handling sensitive documents must complete required awareness and compliance training.",
        ],
      },
      {
        h2: "3. Condition of Employment",
        paragraphs: [
          "All employees, contractors, and partners agree that compliance with this Drug-Free Workplace Policy is a condition of employment, that they must not engage in prohibited drug-related behavior, and that failure to follow the policy will result in disciplinary action.",
          "Employees must also adhere to all local, state, and federal laws related to drug use and possession.",
        ],
      },
      {
        h2: "4. Employee Conviction Notification Requirements",
        paragraphs: [
          "In accordance with federal regulation, employees must notify UPV Services in writing within 5 calendar days if they are convicted of a criminal drug offense occurring in the workplace or while performing company-related duties.",
          "UPV Services will notify the U.S. Department of State within 10 days of receiving such notice, including the employee's position/title.",
        ],
      },
      {
        h2: "5. Company Action After a Reported Conviction",
        paragraphs: [
          "Within 30 days of being notified of an employee's criminal drug conviction, UPV Services will terminate the employee or contractor, or require the individual to participate satisfactorily in a drug abuse assistance or rehabilitation program approved by an appropriate federal, state, or local agency.",
        ],
      },
      {
        h2: "6. Distribution of Policy",
        paragraphs: [
          "All employees and contractors are provided a written copy of this Drug-Free Workplace Policy and required training and documentation confirming compliance. Acknowledgment of this policy is mandatory before performing any courier-related or passport/visa-handling duties.",
        ],
      },
      {
        h2: "7. Commitment to Safety & Compliance",
        paragraphs: [
          "UPV Services is committed to maintaining a secure, safe, and compliant environment for clients and employees. Adhering to a Drug-Free Workplace ensures the highest integrity in handling sensitive U.S. passport and visa documents.",
        ],
      },
    ],
  },
};
